import { useEffect, useState } from "react"
import {useDispatch,useSelector} from 'react-redux'
import { envAwarePost } from "../../util/util"
import {
  selectAllDiets,
  getMAXDiets,
  toggleDietsModal,
  createMAXDiet,
  editMAXDiet,
  removeMAXDiet
} from './MAXSlice'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import { useDebounceCallback } from '@react-hook/debounce'

const MAXDiets = ()=>{
  const dispatch = useDispatch()
  const statusDispatch = useApiStatusDispatch()
  const show = useSelector(state=>state.MAXFoods.diets.show)
  const onHide = ()=>{
    dispatch(toggleDietsModal())
  }
  const loadingStatus = useSelector(state=>state.MAXFoods.diets.status)
  const diets = useSelector(selectAllDiets)
  const [_,setDiets] = useState([])
  const [newDietName,setNewDietName] = useState('')
  const statusPost = useApiStatusEnvAwarePost()
 
  useEffect(()=>{
    dispatch(getMAXDiets())
  },[])

  const [addDietStatus,setAddDietStatus] = useState('idle')
  const handleAddDiet = ()=>{
    setAddDietStatus('pending')
    dispatch(createMAXDiet({name:newDietName})).then( res => {
      setNewDietName('')
      setAddDietStatus('idle')
    })
  }

  const handleDietEdit = (id,name)=>{
    statusDispatch(editMAXDiet({id,name}),'diet','edit')
  }

  const handleRemoveDiet = (id)=>{
    dispatch(removeMAXDiet({id}))
  }

  const debouncedHandleDietEdit = useDebounceCallback(handleDietEdit,500)

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Food Categories</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loadingStatus==='pending'?
          <Spinner animation="border"/>
          :
          <div>
            <div>
              <strong>Add New Category</strong>
              <InputGroup size="sm">
                <Form.Control 
                  onChange={e=>{setNewDietName(e.target.value)}}
                  disabled={addDietStatus==='pending'}
                  placeholder="New Category Name" 
                  value={newDietName}
                />
                <InputGroup.Append>
                  <Button 
                    onClick={handleAddDiet}
                    disabled={addDietStatus==='pending'}
                    variant="outline-success"
                  >
                    {addDietStatus==='pending'?
                      <Spinner animation="border" size="sm"/>
                      :
                      <i className="fa fa-plus"/>
                    }
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </div>
            <hr className="my-2"/>
            <strong>MAX Diets</strong>
            {diets.map(diet=>(
              <div className="mb-2">
                <InputGroup size="sm">
                  <Form.Control  
                    onChange={e=>{
                      const val = e.target.value
                      debouncedHandleDietEdit(diet.id,val)
                    }}
                    placeholder="Category Name" 
                    defaultValue={diet.name}
                  />
                  <InputGroup.Append>
                    <Button 
                      onClick={()=>{handleRemoveDiet(diet.id)}} 
                      variant="outline-danger"
                    >
                      <i className="fa fa-trash"/>
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </div>
            ))}
          </div>
        }
      </Modal.Body>
    </Modal>
  )
}

export default MAXDiets